export const GET_LIST = `common/get-list`;
